import * as stylex from "@stylexjs/stylex";
import { useId } from "react";
import { copy } from "@/copy";
import { NOTE_LIMITS } from "@/domain/schemas";
import "@/theme/tokens.stylex";
import { colors } from "@/theme/tokens.stylex";
import "@/theme/type.stylex";
import { type } from "@/theme/type.stylex";
import { TextInput } from "@/ui/TextInput";
import type { NoteDraft } from "../noteSheet";
type NoteComposerProps = {
  draft: NoteDraft;
  textError: boolean;
  onText: (value: string) => void;
  onAuthor: (value: string) => void;
};
const words = copy.notes.sheet;
export function NoteComposer({
  draft,
  textError,
  onText,
  onAuthor
}: NoteComposerProps) {
  const errorId = useId();
  return <div className="x78zum5 xdt5ytf x1665zp3">
      <textarea data-autofocus aria-label={words.message} aria-invalid={textError || undefined} aria-describedby={textError ? errorId : undefined} placeholder={words.messagePlaceholder} maxLength={NOTE_LIMITS.text} rows={1} value={draft.text} onChange={event => onText(event.target.value)} className="xh8yej3 x5f5z56 xz4f4ph x3d5gib x1odjw0f xc342km x1a2a7pz xtt52l0 x1717udv x1ghz6dp xjbqb8w x1a11ngh x17jlq2w x1eazse7 xo1l8bm x132q4wb xrg9stw" />
      {textError && <span id={errorId} className="xr0iwhn xhunfcg xt3et7w xtvhhri x3258oq">
          {words.writeMessage}
        </span>}
      <TextInput label={words.name} placeholder={words.namePlaceholder} value={draft.author} maxLength={NOTE_LIMITS.author} onChange={onAuthor} />
    </div>;
}